// extracted by mini-css-extract-plugin
module.exports = {"pdpGradient":"product-showcase_pdpGradient__9Y_qw","pdpGrid":"product-showcase_pdpGrid__lmfe8"};